import { Link } from '@tanstack/react-router';

interface CustomerLinkProps {
  customerId: string;
  /** Raw name from the caller's payload; used when there is no ERP name. */
  customerName: string | null;
  /**
   * The customer's name as the source ERP renders it — the `erpDisplayName`
   * field on the payload.
   */
  erpDisplayName: string | null | undefined;
}

export function CustomerLink({
  customerId,
  customerName,
  erpDisplayName,
}: CustomerLinkProps) {
  return (
    <Link
      to="/accounts-receivable/collections/$customerId"
      params={{ customerId }}
      className="text-sm font-medium text-primary hover:underline"
    >
      {erpDisplayName ?? customerName ?? '—'}
    </Link>
  );
}
